// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__9Lz18","actions__plus":"styles_actions__plus__34zr2"};